/*
 * Copyright (c) 2024 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

import ShiftStatus from "pages/Schedule/types/ShiftStatus";

import { ShiftClaimsStatus } from "./types";
import { ShiftBatchStatus } from "../shiftBatches";

export const getShiftStatus = (shiftClaimsStatus: ShiftClaimsStatus): ShiftStatus => {
    switch (shiftClaimsStatus) {
        case ShiftClaimsStatus.Failure:
            return ShiftStatus.Error;
        case ShiftClaimsStatus.Pending:
            return ShiftStatus.Pending;
        case ShiftClaimsStatus.Success:
            return ShiftStatus.Confirmed;

        default:
            return ShiftStatus.Free;
    }
};

export const getShiftBatchStatus = (shiftClaimsStatus: ShiftClaimsStatus): ShiftBatchStatus => {
    switch (shiftClaimsStatus) {
        case ShiftClaimsStatus.Failure:
            return ShiftBatchStatus.Error;
        case ShiftClaimsStatus.Pending:
            return ShiftBatchStatus.Pending;
        case ShiftClaimsStatus.Success:
            return ShiftBatchStatus.Assigned;

        default:
            return ShiftBatchStatus.Free;
    }
};
